import { useState, useRef, useEffect } from 'react';
import EmojiPickerReact from 'emoji-picker-react';

const MJ_EMOJIS = ['🎤','🕺','👑','🌙','✨','💫','🎵','🎶','🖤','🤍','❤️','🌍','🕊️','💝','🎭','🌟'];

export default function EmojiPicker({ onEmojiClick, style }) {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const handleClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleEmoji = (emojiData) => {
    onEmojiClick(emojiData.emoji);
    setOpen(false);
  };

  const handleMJ = (emoji) => {
    onEmojiClick(emoji);
    setOpen(false);
  };

  return (
    <div ref={ref} style={{ position: 'relative', ...style }}>
      <button onClick={() => setOpen(!open)}
        style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', padding: '4px 6px', borderRadius: 6, lineHeight: 1 }}
        title="Emojis">
        😊
      </button>
      {open && (
        <div style={{ position: 'fixed', bottom: 80, right: 20, zIndex: 1000 }}>
          <div style={{ background: '#fff', border: '1px solid #e8d0d0', borderRadius: 12, padding: '10px 12px', marginBottom: 4, boxShadow: '0 4px 16px rgba(0,0,0,0.1)' }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#8b1a2a', letterSpacing: '0.1em', marginBottom: 6 }}>✦ UNIVERS MJ</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
              {MJ_EMOJIS.map(e => (
                <button key={e} onClick={() => handleMJ(e)}
                  style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', padding: '3px', borderRadius: 6, lineHeight: 1 }}
                  onMouseEnter={ev => ev.currentTarget.style.background = '#f5eeeb'}
                  onMouseLeave={ev => ev.currentTarget.style.background = 'none'}>
                  {e}
                </button>
              ))}
            </div>
          </div>
          <EmojiPickerReact
            onEmojiClick={handleEmoji}
            width={300}
            height={350}
            searchPlaceholder="Rechercher..."
            previewConfig={{ showPreview: false }}
          />
        </div>
      )}
    </div>
  );
}
